import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import "./styles.css";

// Load Stripe using your Publishable Key
const stripePromise = loadStripe(
  "pk_live_51TQS0tJwf25gW4YcD4DNcA1oZOjpieisgIoVs3Nw4DDXUmAfwvRGGwkLwmIoKL58HpTZgxdlUCULLTjG1hxqKswi00c0z02y3W"
);

function BasketCheckout() {
  const [basketItems, setBasketItems] = useState([]);
  const [isCheckingOut, setIsCheckingOut] = useState(false);

  // Loads the basket items when you open the page
  useEffect(() => {
    const savedBasket = JSON.parse(localStorage.getItem("basket")) || [];
    setBasketItems(savedBasket);
  }, []);

  // Removes an item from the basket
  const removeItem = (indexToRemove) => {
    const updatedBasket = basketItems.filter(
      (_, index) => index !== indexToRemove
    );
    setBasketItems(updatedBasket);
    localStorage.setItem("basket", JSON.stringify(updatedBasket));
  };

  // Calculates the final total cost
  const totalPrice = basketItems
    .reduce((total, item) => {
      const numericPrice = parseFloat(item.price.replace("£", ""));
      return total + numericPrice;
    }, 0)
    .toFixed(2);

  // Handle Stripe Checkout Redirect
  const handleStripeCheckout = async () => {
    if (basketItems.length === 0) return;

    setIsCheckingOut(true);
    const stripe = await stripePromise;

    if (!stripe) {
      alert("Stripe failed to load.");
      setIsCheckingOut(false);
      return;
    }

    // Note: In a full production app, you would make an API call to your backend
    // to create a Stripe Checkout Session. For direct front-end redirection or
    // testing, you can integrate your backend endpoint URL here.

    // For demonstration, alerting the action if backend isn't linked yet:
    alert(
      "Redirecting to secure Stripe Checkout... (Ensure your backend server is connected to generate Checkout Sessions)."
    );
    setIsCheckingOut(false);
  };

  return (
    <div
      className="container"
      style={{ textAlign: "left", padding: "40px 20px" }}
    >
      <h1 className="main-title">Your Basket & Checkout</h1>
      <p className="prompt-text">
        Review your selected digital products before checkout.
      </p>

      {basketItems.length === 0 ? (
        <div
          style={{
            backgroundColor: "#fffbf5",
            border: "3px solid #2b2621",
            borderRadius: "20px",
            padding: "25px",
            margin: "30px 0",
            boxShadow: "0 4px 0 #2b2621",
          }}
        >
          <p style={{ color: "#666" }}>Your basket is currently empty.</p>
        </div>
      ) : (
        <div>
          <div style={{ margin: "30px 0" }}>
            {basketItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#fffbf5",
                  border: "3px solid #2b2621",
                  borderRadius: "15px",
                  padding: "15px 20px",
                  marginBottom: "15px",
                  boxShadow: "0 3px 0 #2b2621",
                }}
              >
                <div>
                  <h4 style={{ margin: "0 0 5px 0", color: "#2b2621" }}>
                    {item.name}
                  </h4>
                  <span style={{ fontWeight: "bold", color: "#666" }}>
                    {item.price}
                  </span>
                </div>
                <button
                  onClick={() => removeItem(index)}
                  style={{
                    backgroundColor: "#ffb4a2",
                    border: "2px solid #2b2621",
                    borderRadius: "8px",
                    padding: "5px 10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          <div
            style={{
              backgroundColor: "#fffbf5",
              border: "3px solid #2b2621",
              borderRadius: "15px",
              padding: "20px",
              marginBottom: "20px",
              boxShadow: "0 3px 0 #2b2621",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ margin: 0, color: "#2b2621" }}>
              Total: £{totalPrice}
            </h3>

            {/* Stripe Checkout Button */}
            <button
              onClick={handleStripeCheckout}
              disabled={isCheckingOut}
              style={{
                backgroundColor: "#8fa882",
                color: "#2b2621",
                border: "2px solid #2b2621",
                borderRadius: "12px",
                padding: "10px 20px",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 3px 0 #2b2621",
                fontSize: "1rem",
              }}
            >
              {isCheckingOut ? "Processing..." : "Pay with Stripe 🔒"}
            </button>
          </div>
        </div>
      )}

      <div style={{ marginTop: "30px" }}>
        <Link to="/digital-products" className="btn btn-wide">
          ← Continue Shopping
        </Link>
      </div>
    </div>
  );
}

export default BasketCheckout;
